import lang from 'LANG';
import { subscription as subscriptionStatus } from '@/config/status';
import { timeResolve } from '@/common/js/date';

// 套餐名称格式--套餐名（周期）
export function planName ( plan ) {

    return `${plan.title}
        (${lang.tc( `cycle.${plan.cycle.standard.interval.unit}`, plan.cycle.standard.interval.frequency, {
        count: plan.cycle.standard.interval.frequency
    })})`;

}

// 套餐存储历史天数文案
export function planHistory ( plan ) {

    return lang.t( 'plan.history', {
        history: plan.metadata['cloud_storage.video_lifetime']
    });

}

// 套餐支持设备数量文案
export function planCamera ( plan ) {

    return lang.tc( 'plan.camera', plan.metadata['cloud_storage.max_device_quantity'], {
        count: plan.metadata['cloud_storage.max_device_quantity']
    });

}

// 套餐存储空间文案
export function planCapacity ( plan ) {

    return lang.t( 'plan.storage', {
        storage: lang.n(( plan.metadata['cloud_storage.space_capacity'] / 1024 / 1024 / 1024 ).toFixed( 2 ))
    });

}

export function timeFormat ( time ) {

    let {

        year,
        month,
        dateOfMonth,
        hour

    } = timeResolve( time );

    return `${lang.t( 'date_format.default', {

        day: dateOfMonth,
        year,
        month

    })} ${hour}:00`;

}

// 套餐有效期文案格式
export function planValidTime ( sub ) {

    let { status } = sub;
    if ( status === subscriptionStatus.ACTIVE ) {

        let endingAt = sub.cycle.endingAt;
        return timeFormat( endingAt );

    } else if ( status === subscriptionStatus.ACTIVATING || status === subscriptionStatus.DEACTIVATING ) {

        return lang.t( 'dashboard.status.processing' );

    } else if ( sub.expiredAt === 0 ) {

        return lang.t( 'dashboard.status.inactive' );

    } else {

        return lang.t( 'dashboard.status.expired' );

    }

}



// WEBPACK FOOTER //
// ./src/filter/index.js